export const LAXIMO_TOKENS_BALANCE_HEADER = 'X-Laximo-Tokens-Balance';
export const LAXIMO_TOKENS_EXHAUSTED_ERROR_CODE = 'LaximoTokensExhausted';
export const LAXIMO_CATALOG_API_SEGMENT = '/laximo/catalogs';
